import { render } from "./DisCharge.vue?vue&type=template&id=774d5cc4"
import script from "./DisCharge.vue?vue&type=script&lang=js"
export * from "./DisCharge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__